/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '@kubb/plugin-client/clients/fetch';
import type {
  RecordHeartbeatQueryResponse,
  RecordHeartbeatPathParams,
  RecordHeartbeat404,
  RecordHeartbeat409,
} from '../types/RecordHeartbeat.ts';
import type { Client, RequestConfig, ResponseErrorConfig } from '@kubb/plugin-client/clients/fetch';

function getRecordHeartbeatUrl(token: RecordHeartbeatPathParams['token']) {
  const res = { method: 'GET', url: `/heartbeat/${token}` as const };
  return res;
}

/**
 * @description Public endpoint — not protected by ZT. Called by monitored services to signal they are alive. Accepts GET or POST; no request body required. Returns 204 on success.
 * @summary Record a heartbeat check-in
 * {@link /heartbeat/:token}
 */
export async function recordHeartbeat(
  token: RecordHeartbeatPathParams['token'],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<RecordHeartbeatQueryResponse, ResponseErrorConfig<RecordHeartbeat404 | RecordHeartbeat409>, unknown>({
    method: 'GET',
    url: getRecordHeartbeatUrl(token).url.toString(),
    ...requestConfig,
  });
  return res.data;
}
